module.exports = __webpack_public_path__ + "img/login-success.3ffe17ca.png";